import script from "./appointment.vue?vue&type=script&setup=true&lang=js"
export * from "./appointment.vue?vue&type=script&setup=true&lang=js"

import "./appointment.vue?vue&type=style&index=0&id=4d90e492&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Acer\\Desktop\\mav\\surkhet\\patient-portal-v2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d90e492"]])

export default __exports__